import { Link } from 'react-router-dom';

export default function Home() {
  return (
    <>
      <section className="hero">
        <h1>親の声かけ、AIに任せよう。</h1>
        <p className="sub">
          「何時になったら〇〇しなさい」をAIが代わりに伝えます。<br />
          家庭で常時開いておけば、時間になったら自動で読み上げ。<br />
          段階予告・双方向対話まで、3つのレベルで使えます。
        </p>
      </section>

      <div className="level-grid">
        <Link to="/lv1" className="level-card">
          <div className="level-num">Lv1</div>
          <div className="level-title">時刻アナウンス</div>
          <p className="level-desc">登録した時刻になったら、メッセージを1回読み上げます。一番シンプル。</p>
        </Link>

        <Link to="/lv2" className="level-card">
          <div className="level-num">Lv2</div>
          <div className="level-title">段階予告</div>
          <p className="level-desc">本イベント時刻の30分前・15分前・5分前・0分の4段階で自動アナウンス。</p>
        </Link>

        <Link to="/lv3" className="level-card">
          <div className="level-num">Lv3</div>
          <div className="level-title">双方向対話</div>
          <p className="level-desc">アナウンス後にマイクで子どもの応答を聞き取り、AIが返事と次のアラート強度を決めます。</p>
        </Link>
      </div>

      <div className="card" style={{ marginTop: 32 }}>
        <h2>使い方のコツ</h2>
        <ul style={{ paddingLeft: 20, lineHeight: 1.8, color: 'var(--color-muted)' }}>
          <li>このアプリが動くにはブラウザを開いたままにしておく必要があります。</li>
          <li>PCならスリープしない設定、タブレットなら画面OFFにしないでください。</li>
          <li>初回はブラウザがマイク／音声の許可を求めることがあります。</li>
          <li>設定画面で音声エンジンを切り替えられます（既定はブラウザ標準・無料）。</li>
        </ul>
      </div>
    </>
  );
}
